export default __webpack_public_path__ + "static/media/logo-blue.3c72fd3a.svg";